'use client';

import { styled } from '@linaria/react';
import Skeleton from '@fe-common-ui/LoadingSkeleton';

const EmptyContainer = styled.div`
  margin-bottom: 16px;
`;

const NewsListCardSkeleton = () => {
  return (
    <EmptyContainer>
      <Skeleton.NewsSkeleton />
    </EmptyContainer>
  );
};

export default NewsListCardSkeleton;
